import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import Flex from '@Components/Bases/Flex';
import GhGasEmissionVerifyLabel from '@Router/EsgGreenhouse/Components/GhGasEmissionVerifyLabel';
import { VerifyType } from 'src/Enum/EsgGreenhouse';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import ChangeTypeModal from '@Components/Modal/ChangeTypeModal';
import { useDisclosure } from '@hooks/useDisclosure';

const prePath = 'performanceGhGasMgmtReport.ghGasEmissionVerify';

const GreenhouseGasEmissionVerifyForm = () => {
  const {
    formState: { errors },
    setValue,
    trigger,
    unregister,
    watch,
  } = useGreenhouseForm();
  const [opened, { open, close }] = useDisclosure();

  const [verify, completedSection] = watch([
    'performanceGhGasMgmtReport.ghGasEmissionVerify.verify',
    'performanceGhGasMgmtReport.completedSection',
  ]);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  const [selectedVerify, setSelectedVerify] = useState<{
    prev: VerifyType | null;
    current: VerifyType | null;
  }>({ prev: verify ?? null, current: verify ?? null });

  const verifyError =
    errors.performanceGhGasMgmtReport?.ghGasEmissionVerify?.verify;

  const handleConfirm = () => {
    setValue(`${prePath}.verify`, selectedVerify.current as VerifyType);
    unregister(`${prePath}.verifier`);
    setValue(`${prePath}.verifier.infoCategoryMasterDataId`, '');
    setSelectedVerify((select) => ({
      prev: select.current,
      current: null,
    }));
    close();
  };

  const handleClose = () => {
    setSelectedVerify((select) => ({
      ...select,
      current: null,
    }));
    close();
  };

  return (
    <>
      <Flex gap={2}>
        <GhGasEmissionVerifyLabel required>
          การทวนสอบปริมาณการปล่อยก๊าซเรือนกระจกของบริษัท
        </GhGasEmissionVerifyLabel>
        <Box>
          <FormControl fullWidth error={errors ? !!verifyError : undefined}>
            <RadioGroup
              name={`${prePath}.verify`}
              value={selectedVerify.prev ?? ''}
              onChange={(event) => {
                const selectedValue = event.target.value as VerifyType;

                if (
                  selectedVerify.prev === null ||
                  selectedVerify.prev === VerifyType.NO
                ) {
                  setValue(`${prePath}.verify`, selectedValue);
                  setSelectedVerify((select) => ({
                    ...select,
                    prev: selectedValue,
                  }));
                }

                if (
                  selectedVerify.prev === VerifyType.YES &&
                  selectedValue === VerifyType.NO
                ) {
                  open();
                  setSelectedVerify((select) => ({
                    ...select,
                    current: selectedValue,
                  }));
                }

                trigger(`${prePath}.verify`);
              }}
            >
              <FormControlLabel
                label="มี"
                value={VerifyType.YES}
                control={
                  <Radio
                    disabled={isCompletedTh || isCompletedEn}
                    color={verifyError ? 'error' : 'primary'}
                  />
                }
              />
              <FormControlLabel
                label="ไม่มี"
                value={VerifyType.NO}
                control={
                  <Radio
                    disabled={isCompletedTh || isCompletedEn}
                    color={verifyError ? 'error' : 'primary'}
                  />
                }
              />
            </RadioGroup>
          </FormControl>
          {verifyError && (
            <Typography mt={2} variant={'caption'} color={'error.main'}>
              {verifyError.message}
            </Typography>
          )}
        </Box>
      </Flex>
      <ChangeTypeModal
        opened={opened}
        close={handleClose}
        confirm={handleConfirm}
      />
    </>
  );
};

export default GreenhouseGasEmissionVerifyForm;
